import { render, staticRenderFns } from "./app-header-message.vue?vue&type=template&id=effb598a"
import script from "./app-header-message.vue?vue&type=script&lang=js"
export * from "./app-header-message.vue?vue&type=script&lang=js"
import style0 from "./app-header-message.vue?vue&type=style&index=0&id=effb598a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports